/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineRequest {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineRequest.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineRequest>): AIUnitEconomicsBaselineRequest {
        let obj = Object.assign(new AIUnitEconomicsBaselineRequest(), model);
        AIUnitEconomicsBaselineRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineRequest>): AIUnitEconomicsBaselineRequest {
        if (!model) return null;
        return AIUnitEconomicsBaselineRequest.newInstance(<AIUnitEconomicsBaselineRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineRequest) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineRequest): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.quality_scale === undefined) {
            this.quality_scale = 0;
        }
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.configuration) {
            for (let val of this.configuration) {
                models.AIUnitEconomicsBaselineConfigurationEntry.fixupPrototype(val);
            }
        }
    }

    /**
     * Display name of the baseline
     */
    name: string;

    /**
     * Scope the baseline applies to. 'tenant' requires applicable_entity_id; 'master_account' must omit it and applies to the caller's master account
     */
    scope: models.AIUnitEconomicsBaselineScope;

    /**
     * Entity the baseline applies to: the tenant ID when scope is 'tenant'. Must be omitted when scope is 'master_account'; the caller's master account is used
     */
    applicable_entity_id: string;

    /**
     * First day the baseline applies to
     */
    start_date: Date;

    /**
     * End of the baseline period (exclusive); must be later than start_date
     */
    end_date: Date;

    /**
     * Field the consolidation job matches cost on (e.g. 'agent_id'). Immutable after creation
     */
    primary_key: string;

    /**
     * Unit the manual and AI duration fields are expressed in
     */
    duration_unit: models.AIUnitEconomicsDurationUnit;

    /**
     * Upper bound for the quality score fields (e.g. 5)
     */
    quality_scale: number;

    /**
     * Baseline entries, one per primary key value
     */
    configuration: Array<models.AIUnitEconomicsBaselineConfigurationEntry>;

}
